<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-NoSelected`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_f5b1fc4e4a__clip0_591_1504)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 15C11.0899 15 14 12.0899 14 8.5C14 4.91015 11.0899 2 7.5 2C3.91015 2 1 4.91015 1 8.5C1 12.0899 3.91015 15 7.5 15ZM7.49995 13.4999C10.2338 13.4999 12.45 11.2837 12.45 8.5499C12.45 5.81609 10.2338 3.5999 7.49995 3.5999C4.76614 3.5999 2.54995 5.81609 2.54995 8.5499C2.54995 11.2837 4.76614 13.4999 7.49995 13.4999Z"/></g><defs><clipPath id="svg_f5b1fc4e4a__clip0_591_1504"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconNoSelected',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
